<script setup lang="ts">
import LargeDialog from './LargeDialog.vue'

const dialogStore = useDialogStore()
const dialog = dialogStore.video
const { $music } = useNuxtApp()

watch(
  () => dialog.visible,
  (visible) => {
    if (visible) {
      $music.pauseMusic()
    }
    else {
      $music.resumeMusic()
    }
  },
)

const onCancel = () => {
  dialogStore.closeDialog('video', 'cancel')
}
</script>

<template>
  <LargeDialog
    v-if="dialog.params"
    :title="dialog.params.title || '動画'"
    :model-value="dialog.visible"
    :cancel-button="{ title: 'とじる' }"
    @cancel="onCancel"
  >
    <template #default>
      <YouTube :video-id="dialog.params.text" />
    </template>
  </LargeDialog>
</template>

<style scoped>
.youtube-outer {
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.youtube-inner {

  width: 100%;
  max-width: 1280px;
  aspect-ratio: 16 / 9;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
}

div.youtube-mark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
